import * as R from "ramda";
import { MainState } from "../../reducer";
import { NotePageData, NotebookPage } from "../../types/note";
import { NoteBlock } from "../../types/notebook/note/block";
import { HtmlBlock } from "../../types/notebook/note/block/html";

export const assignNotebookPage: (
  state: MainState,
  page: NotebookPage,
) => MainState = (state, page) => {
  const { notebookPages } = state;
  const pageId = page["page-id"];
  const newNotebookPages = R.assoc(pageId, page, notebookPages);
  return { ...state, notebookPages: newNotebookPages };
};

export const selectedPage: (state: MainState) => NotebookPage | undefined = (
  state,
) => {
  const { selectedNotebookPageId, notebookPages } = state;
  return selectedNotebookPageId
    ? notebookPages[selectedNotebookPageId]
    : undefined;
};

export const pageBlocks: (
  state: MainState,
  pageId: string | undefined,
) => NoteBlock[] = (state, pageId) => {
  if (!pageId) return [];
  const blocksMap = state.pageBlocks;
  return blocksMap[pageId] ?? [];
};

export const flushNoteEdits: (state: MainState) => MainState = (state) => {
  const { noteEdits } = state;
  const blocks = pageBlocks(state, state.selectedNotebookPageId);
  const newBlocks = blocks.map((block, i) => {
    const edit = noteEdits[i];
    return edit ? { ...block, html: edit } : block;
  });
  const withBlocks = setSelectedPageBlocks(state, newBlocks);
  return { ...withBlocks, noteEdits: {} };
};

export const selectedPageBlocks: (state: MainState) => NoteBlock[] = (
  state,
) => {
  const pageId = state.selectedNotebookPageId;
  const blocksMap = state.pageBlocks;
  const blocks = pageId ? blocksMap[pageId] : undefined;
  return blocks ?? [];
};

export const setSelectedPageBlocks: (
  state: MainState,
  newBlocks: NoteBlock[],
) => MainState = (state, newBlocks) => {
  const { notebookPages, selectedNotebookPageId } = state;
  const page = selectedPage(state)!;
  const blocksMap = state.pageBlocks;
  const newBlocksMap = { ...blocksMap, [selectedNotebookPageId!]: newBlocks };
  return { ...state, pageBlocks: newBlocksMap };
};

export const setHtmlBlockEdit: (block: HtmlBlock, edit: string) => HtmlBlock = (
  block,
  edit,
) => {
  return { ...block, html: edit };
};

export const produceNestedBullets: (level: number) => string = (level) => {
  const newHtml = R.reduce(
    (acc, _) => `<ul><li>${acc}</li></ul>`,
    `<p>test this</p>`,
    R.range(0, level),
  );
  // console.log("LEVEL", level, newHtml);
  return newHtml;
};

export const dragIndex: <T>(arr: T[], active: number, over: number) => T[] = (
  arr,
  active,
  over,
) => {
  const moveUp = over < active;
  const insertIndex = moveUp ? over : over + 1;
  const removeIndex = moveUp ? active + 1 : active;
  const elem = arr[active];
  const moveIndex = R.pipe(
    R.insert(insertIndex, elem),
    R.remove(removeIndex, 1),
  );
  const newArr = moveIndex(arr);
  return newArr;
};
